import Icon from './Icon'
import { iconToComponent } from './iconToComponent'

import './style/css'

export default Icon

export type IconType = keyof typeof iconToComponent
